import { Box, Typography } from "@mui/material";

const Reporting = () => (
  <Box>
    <Typography variant={"h2"}>Reporting</Typography>
    <Typography variant={"body1"}>Reporting body copy here</Typography>
  </Box>
);

export default Reporting;
